<div class="agency-header agency-header__container">
  <ng-container *var="agency$ | async as agency">
    <div class="agency-header__image-container">
      <ag-shr-image-with-loader
        class="agency-header__image"
        [wasabiPath]="agency?.head_shot?.wasabiPath"
        [cropperPayload]="agency?.head_shot?.imageCropperPayload"
        [mediaSize]="MediaSize.origin"
      ></ag-shr-image-with-loader>

      <dx-drop-down-button
        *ngIf="Entity.agencyEditPicture | hasPermission: EntityPermissionActivityKeys.write | async"
        class="agency-campaign-picture__button"
        [showArrowIcon]="false"
        [dropDownOptions]="{ width: 230 }"
        [useItemTextAsTitle]="false"
        icon="edit"
        stylingMode="text"
        [items]="[
          {
            icon: 'mdi mdi-upload',
            text: 'Add Picture',
            onClick: onUploadClicked,
            visible: Entity.agencyEditPicture | hasPermission: EntityPermissionActivityKeys.create | async,
          },
          {
            icon: 'mdi mdi-pencil',
            text: 'Edit Thumbnail',
            onClick: handleCropImage,
            visible: !!agency?.head_shot?.wasabiPath,
            disabled: !(Entity.agencyEditPicture | hasPermission: EntityPermissionActivityKeys.write | async),
          },
        ]"
      ></dx-drop-down-button>

      <ag-shr-media-uploader-modal
        [mediaPathPrefix]="mediaPathPrefix"
        [waitForProcessing]="true"
        (mediaChanged)="onMediaChanged($event)"
        [mediaItems]="agencyMediaDataSource$ | async"
      ></ag-shr-media-uploader-modal>

      <ag-shr-image-cropper-modal
        [onImageCropped]="onImageCropped"
        [title]="'Edit Thumbnail'"
        [roundCropper]="false"
        [maintainAspectRatio]="false"
        [isLoading]="isPreparingHeadshotCropperSig()"
      ></ag-shr-image-cropper-modal>
    </div>

    <div class="col">
      <div class="row align-items-center">
        <div class="col-8 agency-header__title">
          <span>
            {{ agency?.name }}
            <i
              class="dx-icon-favorites superscript-icon"
              *ngIf="agency?.agency_type === agencyType.MGA"
              title="MGA"
            ></i>
          </span>

          <dx-button
            *ngIf="Entity.agencyInformation | hasPermission: EntityPermissionActivityKeys.write | async"
            class="mr-2"
            icon="edit"
            stylingMode="text"
            (onClick)="showEditorModal()"
          ></dx-button>

          <i
            class="dx-icon-agi-trophy trophy-icon"
            *ngIf="agency?.relationshipWithAG?.isFoundingMember"
            title="Founding Member"
          ></i>
        </div>
      </div>

      <div class="row pb-3">
        <div class="col">
          <p class="mb-0" *ngIf="agency?.agency_type !== agencyType.MGA">
            MGA: {{ agency?.mga | mgaName: (mgas$ | async) }}
          </p>

          <p class="mb-0">Agency ID: {{ agency?.agency_id }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <div class="pb-1">
            <div class="agency-header__key">Office Email Address</div>
            <div class="agency-header__value" [class.ag-empty-text]="!agency?.officeEmailAddress?.length">
              {{ agency?.officeEmailAddress | AgencyPrimaryEmailAddress | empty: "n/a" }}
            </div>
          </div>

          <div class="pb-1">
            <div class="agency-header__key">Office Phone Number</div>
            <div class="agency-header__value" [class.ag-empty-text]="!agency?.officePhoneNumbers?.length">
              {{ agency?.officePhoneNumbers | primaryPhoneNumber | phoneNumberMask | empty: "n/a" }}
            </div>
          </div>
        </div>

        <div class="col-auto">
          <div class="agency-header__key">Office Mailing Address</div>
          <div class="agency-header__value" *var="agency?.addresses as addresses">
            <p class="mb-0">{{ addresses | primaryShippingAddress | fullAddress: null : "street" }}</p>
            <p class="mb-0">{{ addresses | primaryShippingAddress | fullAddress: null : "other" }}</p>
            <p class="mb-0 ag-empty-text" *ngIf="!addresses?.length">n/a</p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ag-shr-modal-window
  [width]="'auto'"
  [height]="'auto'"
  #agenyCompanyLogoModalRef
  [title]="'Agency Logo'"
  [inProgress]="inProgress$ | async"
  (onSaveClick)="saveAgencyLogoImagesUpdates()"
  [onCloseModal]="handleClosePopup"
>
  <ag-shr-drop-zone
    #agencyLogoDropZoneRef
    [pictureUrl]="headerLink$ | async"
    (pictureUrlChange)="onPictureUrlChange($event)"
    [textBoxLabel]="'Company Logo URL'"
    [imageCroperTitle]="'Crop Company Logo Picture'"
    [roundCropper]="false"
    [ratio]="aspectRatio"
    [showToolbar]="true"
  ></ag-shr-drop-zone>
</ag-shr-modal-window>

<ag-shr-agency-info-modal #agencyInfoModalRef></ag-shr-agency-info-modal>
